//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../Display/Display.PointCloudClippingBoxesListItemBuilderList.js";
import "../no/ObjectList.js";
let d=[[[1,"ClippingBoxesList",0,"Display.PointCloudClippingBoxesListItemBuilderList",0],[0,"LoadPointDataWithPart",1,0],[0,"PointBrightnessMode",1,0],[0,"PointColorMode",1,0],[0,"PointDataFile",1,0],[0,"PointDensity",1,0],[0,"PointSize",1,0]],[[[],"LoadPointData",{},0,0],[[],"CreateClippingBoxesListItemBuilder",{R_:{listitem:"Display.PointCloudClippingBoxesListItemBuilder"}},0,0]],[]];
SPLM.Display.PointCloudBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.PointCloudBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.PointCloudBuilder.ColorModes = Object.freeze({
    "Individual" : "Individual", "Uniform" : "Uniform"});

SPLM.Display.PointCloudBuilder.BrightnessModes = Object.freeze({
    "Uniform" : "Uniform", "Shaded" : "Shaded"});

export default SPLM;